import Vue from 'vue'
import Router from 'vue-router'

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')
// Views
const Dashboard = () => import('@/views/Dashboard')
const Login = () => import('@/views/auth/Login')
const ArticlesList = () => import('@/views/articles/List')
const ArticleUpdate = () => import('@/views/articles/Update')
const ArticleByID = () => import('@/views/articles/Article')
const ServicesList = () => import('@/views/services/List')
const ServiceUpdate = () => import('@/views/services/Update')
const ServiceByID = () => import('@/views/services/Service')
import Gallery from '@/views/gallery'
const LanguageList = () => import('@/views/languages/List')
const LanguageUpdate = () => import('@/views/languages/Update')
const LanguageByID = () => import('@/views/languages/Language')
const PromotionList = () => import('@/views/promotions/List')
const PromotionUpdate = () => import('@/views/promotions/Update')
const PromotionByID = () => import('@/views/promotions/Promotion')
const ReviewList = () => import('@/views/reviews/List')
const ReviewUpdate = () => import('@/views/reviews/Update')
const DoctorList = () => import('@/views/doctors/List')
const DoctorUpdate = () => import('@/views/doctors/Update')
const OptionUpdate = () => import('@/views/options/Update')

Vue.use(Router)

const router = new Router({
  mode: 'history', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
  {
    path: '/',
      //redirect: '/dashboard',
      name: 'Home',
      component: DefaultContainer,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard
        },{
          path: 'articles',
          redirect: '/articles/list',
          name: 'Articles',
          component: {
            render (c) { return c('router-view') }
          },
          children: [{
            path: 'view/:slug',
            name: 'ArticleByID',
            component: ArticleByID
          },{
            path: 'list',
            name: 'ArticleList',
            component: ArticlesList
          },{
            path: 'add',
            name: 'ArticleAdd',
            component: ArticleUpdate
          },{
            path: 'edit/:id',
            name: 'ArticleEdit',
            component: ArticleUpdate
          }]
        },{
          path: 'languages',
          redirect: '/languages/list',
          name: 'Languages',
          component: {
            render (c) { return c('router-view') }
          },
          children: [{
            path: 'view/:slug',
            name: 'LanguageByID',
            component: LanguageByID
          },{
            path: 'list',
            name: 'LanguageList',
            component: LanguageList
          },{
            path: 'add',
            name: 'LanguageAdd',
            component: LanguageUpdate
          },{
            path: 'edit/:id',
            name: 'LanguageEdit',
            component: LanguageUpdate
          }]
        },{
          path: 'promotions',
          redirect: '/promotions/list',
          name: 'Promotions',
          component: {
            render (c) { return c('router-view') }
          },
          children: [{
            path: 'view/:slug',
            name: 'PromotionByID',
            component: PromotionByID
          },{
            path: 'list',
            name: 'PromotionList',
            component: PromotionList
          },{
            path: 'add',
            name: 'PromotionAdd',
            component: PromotionUpdate
          },{
            path: 'edit/:id',
            name: 'PromotionEdit',
            component: PromotionUpdate
          }]
        },{
          path: 'services',
          redirect: '/services/list',
          name: 'Services',
          component: {
            render (c) { return c('router-view') }
          },
          children: [{
            path: 'view/:slug',
            name: 'ServiceByID',
            component: ServiceByID
          },{
            path: 'list',
            name: 'ServicesList',
            component: ServicesList
          },{
            path: 'add',
            name: 'ServiceAdd',
            component: ServiceUpdate
          },{
            path: 'edit/:id',
            name: 'ServiceEdit',
            component: ServiceUpdate
          }]
        },{
          path: 'reviews',
          redirect: '/reviews/list',
          name: 'Reviews',
          component: {
            render (c) { return c('router-view') }
          },
          children: [{
            path: 'list',
            name: 'ReviewList',
            component: ReviewList
          },{
            path: 'add',
            name: 'ReviewAdd',
            component: ReviewUpdate
          },{
            path: 'edit/:id',
            name: 'ReviewEdit',
            component: ReviewUpdate
          }]
        },{
          path: 'doctors',
          redirect: '/doctors/list',
          name: 'Doctors',
          component: {
            render (c) { return c('router-view') }
          },
          children: [{
            path: 'list',
            name: 'DoctorList',
            component: DoctorList
          },{
            path: 'add',
            name: 'DoctorAdd',
            component: DoctorUpdate
          },{
            path: 'edit/:id',
            name: 'DoctorEdit',
            component: DoctorUpdate
          }]
        },{
          path: 'settings',
          name: 'Setting',
          component: OptionUpdate
        },
        {
          path: 'gallery',
          name: 'Gallery',
          component: Gallery
        },
        {
          path: 'logout',
          name: 'Logout',
          component: () => {
            localStorage.removeItem('z_token')
            localStorage.removeItem('z_site_url')
            location.reload();
          }
        }
      ]
    },
    {
      path: '/auth',
      redirect: '/auth/login',
      name: 'Auth',
      component: {
        render (c) { return c('router-view') }
      },
      children: [{
        path: 'login',
        name: 'Login',
        component: Login
      }]
    }
    ]
  })

router.beforeEach(async(to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/auth/login']
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('z_token');

  if (authRequired && !loggedIn) {
    return next('/auth/login')
  } else if (publicPages.includes(to.path) && loggedIn) {
    try {
      await Vue.http.get(process.env.VUE_APP_AUTH_URL + 'api/v1/users/me')
      return next('/dashboard')
    } catch (error) {
      return next('/auth/login')
    }
  }
  next()
})

export default router
